
export default class InverseDistanceWeightProcessor {

  /**
   * Constructor
   * @param p
   */
  constructor(p) {
    this._p = p;
  }

  /**
   * @param referenceData
   * @param nearestNeighbours
   * @param currentSiteId
   * @return array data
   */
  process(referenceData, nearestNeighbours, currentSiteId) {

    // If point on top of grid point, use grid point.
    if (nearestNeighbours[0].squaredDistance === 0) {
      let neighbourId = nearestNeighbours[0].siteId;
      let neighbourRow = referenceData[neighbourId];

      return neighbourRow.data;
    } else {
      /*
      Else
        sum(xi/di)
        ----------
        sum(1/di)
      xi = grid point i (one of the 4 nerest neighbour points we use for the interpolation)
      di = distance between point and xi
      */

      let dataLength = referenceData[currentSiteId].data.length,
        data = [];

      for (let j = 0; j < dataLength; j++) {
        let sum_xi_di = 0,
          sum_1_di = 0;

        for (let i = 0; i < nearestNeighbours.length; i++) {
          if (nearestNeighbours[i] !== null && nearestNeighbours[i].siteId !== null) {
            let neighbour = nearestNeighbours[i],
              neighbourId = neighbour.siteId,
              neighbourRow = referenceData[neighbourId];

            let xi = neighbourRow.data[j],
              di = Math.pow(neighbour.squaredDistance, this._p / 2);

            sum_xi_di += xi / di;
            sum_1_di += 1 / di;
          }
        }

        data[j] = sum_xi_di / sum_1_di;
      }

      return data;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/algorithm-processor/inverse-distance-weight-processor.js